/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { PlanningActionMetadataDtoModel, PlanningActionMetadataDtoModelType } from "./PlanningActionMetadataDtoModel"
import { PlanningActionMetadataDtoModelSelector } from "./PlanningActionMetadataDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ReversiblePlanningActionsDtoBase
 * auto generated base class for the model ReversiblePlanningActionsDtoModel.
 */
export const ReversiblePlanningActionsDtoModelBase = ModelBase
  .named('ReversiblePlanningActionsDto')
  .props({
    __typename: types.optional(types.literal("ReversiblePlanningActionsDto"), "ReversiblePlanningActionsDto"),
    lastUndoablePlanningAction: types.union(types.undefined, types.null, types.late((): any => PlanningActionMetadataDtoModel)),
    nextRedoablePlanningAction: types.union(types.undefined, types.null, types.late((): any => PlanningActionMetadataDtoModel)),
    planningActions: types.union(types.undefined, types.null, types.array(types.late((): any => PlanningActionMetadataDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ReversiblePlanningActionsDtoModelSelector extends QueryBuilder {
  lastUndoablePlanningAction(builder: string | PlanningActionMetadataDtoModelSelector | ((selector: PlanningActionMetadataDtoModelSelector) => PlanningActionMetadataDtoModelSelector) | undefined) { return this.__child(`lastUndoablePlanningAction`, PlanningActionMetadataDtoModelSelector, builder) }
  nextRedoablePlanningAction(builder: string | PlanningActionMetadataDtoModelSelector | ((selector: PlanningActionMetadataDtoModelSelector) => PlanningActionMetadataDtoModelSelector) | undefined) { return this.__child(`nextRedoablePlanningAction`, PlanningActionMetadataDtoModelSelector, builder) }
  planningActions(builder: string | PlanningActionMetadataDtoModelSelector | ((selector: PlanningActionMetadataDtoModelSelector) => PlanningActionMetadataDtoModelSelector) | undefined) { return this.__child(`planningActions`, PlanningActionMetadataDtoModelSelector, builder) }
}
export function selectFromReversiblePlanningActionsDto() {
  return new ReversiblePlanningActionsDtoModelSelector()
}

export const reversiblePlanningActionsDtoModelPrimitives = selectFromReversiblePlanningActionsDto()
